import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsMap from 'highcharts/modules/map';
import HighchartsReact from 'highcharts-react-official';
import { feature } from 'topojson-client';
import topoJson from './chiefdoms.json';

HighchartsMap(Highcharts);

const MapChart = ({ data, title }) => {
    const [chartOptions, setChartOptions] = useState({
        chart: {
            height: 500,
            margin: [60, 20, 80, 20],
            spacing: [0, 0, 0, 0],
        },
        title: {
            text: 'Loading...',
            align: 'center',
            verticalAlign: 'middle'
        },
        credits: {
            enabled: false
        }
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [geoJsonData, setGeoJsonData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const convertedData = feature(topoJson, topoJson.objects.chiefdoms);
                setGeoJsonData(convertedData);

                const year = Object.keys(data)[0];
                const formattedData = data[year]
                    .filter(item => item.longitude && item.latitude)
                    .map(item => ({
                        x: parseFloat(item.longitude),
                        y: parseFloat(item.latitude),
                        location: item.location,
                        value: item.total_girls,
                        year: item.year
                    }));

                    const valueMap = formattedData.reduce((acc, item) => {
                        const nameParts = item.location.split(' ');
                        const filteredParts = nameParts.filter(part => part !== 'Chiefdom');
                        const name = filteredParts.join(' ');
                        acc[name] = item.value;
                        return acc;
                    }, {});
                    
                const seriesData = convertedData.features.map(feature => {
                    const locationName = feature.properties.name; 
                    const value = valueMap[locationName] || 0; 
                    return {
                        name: locationName,
                        value: value
                    };
                });
                console.log('seriesData',seriesData);

                setChartOptions({
                    chart: {
                        type: 'map',
                        height: 500,
                        margin: [55, 20, 80, 2],
                        spacing: [0.5, 0.5, 0.5, 0.5],
                    },
                    title: {
                        text: title,
                        align: 'center',
                        verticalAlign: 'top'
                    },
                    mapNavigation: {
                        enabled: false,
                        buttonOptions: {
                            verticalAlign: 'bottom'
                        }
                    },
                    colorAxis: {
                        min: 0,
                        minColor: '#CCCCCC', 
                        max: Math.max(...seriesData.map(d => d.value)) || 1,
                        type: 'linear',
                        labels: {
                            format: '{value}'
                        },
                        stops: [
                            [0, '#CCCCCC'], //For the grey color
                            [0.0001, '#FF0000'], // light red for low value color
                            [0.5, '#FFFF00'], // light yellow for mid value color
                            [1, '#00FF00']  // light green for high value color
                        ]
                    },
                    series: [{
                        data: seriesData,
                        mapData: convertedData,
                        joinBy: ['name', 'name'],
                        name: 'Coverage In/Out per Chiefdom',
                        states: {
                            hover: {
                                color: '#BADA55'
                            }
                        },
                        dataLabels: {
                            enabled: true,
                            formatter: function () {
                                return this.point.value > 0 ? this.point.name : null;
                            }
                        },
                        credits: {
                            enabled: false
                        }

                    }]
                });

                setLoading(false);
            } catch (error) {
                setError(error);
                setLoading(false);
            }
        };

        fetchData();
    }, [data]);

    if (loading){
        return <p>Loading...</p>;
    } 

    return (
        <div>
            <HighchartsReact
                highcharts={Highcharts}
                constructorType="mapChart"
                options={chartOptions}
            />
        </div>
    );
};

export default MapChart;
